/**
 * SliderImage component.
 */
import DeviceConfig from '@devices/config';
import PhotoDefault from '../../../../shared/assets/images/png/photoDefault.png';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

/**
 * Props for the SliderImage component.
 */
interface Props {
  height: number;
  width: number;
  src: string;
}

/**
 * Styled slider image.
 */
const SliderImage = styled.img<Props>`
  cursor: pointer;
  display: flex;
  height: ${720 * Screen.widthRatio}px;
  object-fit: ${() =>
    DeviceConfig.capabilities.image.disableFitCover ? 'unset' : 'cover'};
  overflow: hidden;
  position: relative;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 1;
`;

/**
 * Default props for the slider image.
 */
SliderImage.defaultProps = {
  src: PhotoDefault,
};

export default withImage(SliderImage, true);
